// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CodepenCircleFilledSvg from "@ant-design/icons-svg/es/asn/CodepenCircleFilled";
import AntdIcon from '../components/AntdIcon';

var CodepenCircleFilled = function CodepenCircleFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CodepenCircleFilledSvg
  }));
};

CodepenCircleFilled.displayName = 'CodepenCircleFilled';
export default React.forwardRef(CodepenCircleFilled);